import { getDisclosures } from './disclosures-util'
import { SURFACE_PROTECTION, PRIORCREDITORLEASEOWEDONTRADE } from 'constants/pdsConstant'

const disclosures = getDisclosures()

export const formatPriceChanges = (response, documentFeeName) => {
    const details = [
        {
            key: 'dealerAdjustmentPrice',
            name: disclosures.dealerAdjustments.name,
            order: disclosures.dealerAdjustments.order
        },
        {
            key: 'dealerInstalledOptions',
            name: disclosures.totalDealerInstalledOptions.name,
            order: disclosures.totalDealerInstalledOptions.order
        },
        {
            key: 'capitalizedCostReduction',
            name: disclosures.totalCapitalizedCostReduction.name,
            order: disclosures.totalCapitalizedCostReduction.order
        },
        { key: 'taxesAndFees', name: disclosures.totalTaxesAndFees.name, order: disclosures.totalTaxesAndFees.order },
        {
            key: 'netTradeinAllowance',
            name: disclosures.netTradeInAllowance.name,
            order: disclosures.netTradeInAllowance.order
        },
        {
            key: 'adjustedCapitalizedCost',
            name: disclosures.adjustedCapCost.name,
            order: disclosures.adjustedCapCost.order
        },
        {
            key: 'documentFee',
            name: documentFeeName || disclosures.documentFee.name,
            order: disclosures.documentFee.order
        },
        {
            key: 'incentive',
            name: disclosures.currentAvailableIncentives.name,
            order: disclosures.currentAvailableIncentives.order
        },
        {
            key: 'cashAmountDueAtDealer',
            name: disclosures.cashDueAtDealer.name,
            order: disclosures.cashDueAtDealer.order
        },
        {
            key: 'accessories',
            name: disclosures.totalCostOfAccessories.name,
            order: disclosures.totalCostOfAccessories.order
        },
        {
            key: 'protectionPlan',
            name: disclosures.insuranceWarranties.name,
            order: disclosures.insuranceWarranties.order
        },
        { key: 'surfaceProduction', name: SURFACE_PROTECTION, order: false },
        { key: 'cashDownPayment', name: disclosures.cashDownPayment.name, order: disclosures.cashDownPayment.order },
        { key: 'dealerDiscount', name: disclosures.dealerDiscount.name, order: disclosures.dealerDiscount.order },
        {
            key: 'priorCreditOrLeaseBalance',
            name: PRIORCREDITORLEASEOWEDONTRADE,
            order: false
        },
        {
            key: 'federalEVTaxCredit',
            name: disclosures.federalEVTaxCredit.name,
            order: disclosures.federalEVTaxCredit.order
        }
    ]

    const filteredDetails = details
        .filter((detail) => response?.[detail.key])
        .map((detail) => ({
            name: detail.name,
            badge: true,
            badgeContent: detail.order,
            value: response[detail.key]
        }))

    return filteredDetails.length > 0 ? { details: filteredDetails } : null
}
